import { connect } from 'react-redux';
import { getTickets, getLaundryRooms, getPaymentMethods, purchaseTicket, resetPage, resetMeta, getLaundryRoomMachines } from '../../actions/TicketPage';
import TicketPage from './TicketPage';

const mapsStateToProps = state => ({
	ticketPageProps: state.ticketPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getTickets() {
		dispatch(getTickets());
	},
	getLaundryRooms() {
		dispatch(getLaundryRooms());
	},
	getLaundryRoomMachines() {
		dispatch(getLaundryRoomMachines());
	},
	getPaymentMethods() {
		dispatch(getPaymentMethods());
	},
	purchaseTicket(details) {
		dispatch(purchaseTicket(details));
	},
	resetPage() {
		dispatch(resetPage());
	},
	resetMeta() {
		dispatch(resetMeta());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(TicketPage);
